const en = {
  // Nav
  nav_home: "Home",
  nav_about: "About",
  nav_products: "Products",
  nav_exports: "Exports",
  nav_certifications: "Certifications",
  nav_blog: "News & Vlogs",
  nav_contact: "Contact",
  nav_call: "Call Now",

  // Hero
  hero_tagline: "Established Exporters of Premium Rice",
  hero_desc: "Royal Basmati Rice, cultivated in the fertile plains of India. Trusted by importers across Africa, Indonesia & Canada.",
  hero_explore: "Explore Products",
  hero_quote: "Request a Quote",

  // Stats
  stat_varieties: "Rice Varieties",
  stat_countries: "Countries Exported",
  stat_tonnes: "Tonnes Exported",
  stat_quality: "Quality Assured",

  // About Teaser
  about_tag: "Heritage & Trust",
  about_title_1: "Rooted in Quality,",
  about_title_2: "Grown",
  about_title_3: "with Pride",
  about_desc1: "P.S.IMPEX, led by founder Manjot Singh, has established itself as a premier rice exporter from India. Our brand Fab Crops represents the finest selection of Basmati and Non-Basmati rice, sourced directly from the lush paddy fields of Punjab.",
  about_desc2: "With certifications from FSSAI, APEDA, and ISO, we ensure every grain meets the highest international standards. Our commitment to organic practices and sustainable farming sets us apart.",
  about_learn: "Learn Our Story",

  // Products Overview
  products_tag: "Our Collection",
  products_title: "Premium Rice Varieties",
  basmati_tag: "Premium Selection",
  basmati_title: "Basmati Rice",
  basmati_desc: "The crown jewel of Indian rice exports. Long-grain, aromatic, and perfectly aged. Available in 1121, 1718, 1509, 1401 & Pusa varieties.",
  basmati_view: "View All Varieties",
  prf_tag: "Certified Safe",
  prf_title: "Pesticide Residue Free",
  prf_desc: "Certified PRF rice for health-conscious global markets. Meeting the strictest international food safety standards.",
  prf_view: "View PRF Varieties",
  nonbasmati_tag: "Everyday Excellence",
  nonbasmati_title: "Non-Basmati Rice",
  nonbasmati_desc: "High-quality non-basmati rice varieties for bulk consumption and industrial use. Consistent quality, competitive pricing.",
  nonbasmati_view: "View All Varieties",

  // Export Section
  export_tag: "Global Presence",
  export_title_1: "Exporting Trust",
  export_title_2: "Worldwide",
  export_desc: "As a recognized high-volume exporter, P.S.IMPEX ships premium Indian rice to multiple continents. Our robust supply chain ensures timely delivery while maintaining uncompromised quality standards.",
  export_africa: "Africa",
  export_africa_desc: "Major markets across West and East Africa",
  export_indonesia: "Indonesia",
  export_indonesia_desc: "Consistent supply to Indonesian distributors",
  export_canada: "Canada",
  export_canada_desc: "Serving the growing South Asian diaspora",
  export_europe: "Europe",
  export_europe_desc: "Expanding presence across European markets",
  export_middleeast: "Middle East",
  export_middleeast_desc: "Trusted supplier to Gulf & Middle Eastern importers",

  // Certifications
  cert_fssai: "FSSAI Certified",
  cert_apeda: "APEDA Registered Exporter",
  cert_iso: "ISO 9001:2015 Certified",
  cert_lei: "LEI Registered",
  cert_premium: "Premium Quality Rice",
  cert_global: "Trusted Global Exporter",

  // Testimonials
  test_tag: "Client Voices",
  test_title: "Trusted by Importers",

  // CTA
  cta_tag: "Partner With Us",
  cta_title: "Ready to Source Premium Rice?",
  cta_desc: "Connect with P.S.IMPEX for competitive pricing, reliable supply, and the finest quality Indian rice for your markets.",
  cta_btn: "Get in Touch",

  // Contact
  contact_tag: "Contact Us",
  contact_title_1: "Let's Talk",
  contact_title_2: "Business",
  contact_desc: "Whether you're an importer, distributor, or wholesaler looking for premium Indian rice, we'd love to hear from you.",
  contact_direct: "Direct Contact",
  contact_phone: "Phone",
  contact_email: "Email",
  contact_company: "Company",
  contact_hours: "Business Hours",
  contact_weekdays: "Monday - Saturday",
  contact_weekend: "Sunday",
  contact_closed: "Closed",
  contact_form_title: "Send Us a Message",
  contact_form_desc: "Fill out the form below and we'll get back to you within 24 hours.",
  contact_name: "Full Name",
  contact_email_label: "Email",
  contact_phone_label: "Phone",
  contact_company_label: "Company",
  contact_message: "Message",
  contact_message_placeholder: "Tell us about your requirements (rice type, quantity, destination)...",
  contact_submit: "Send Message",
  contact_sending: "Sending...",
  contact_success: "Thank you! We'll get back to you soon.",
  contact_error: "Something went wrong. Please try again.",

  // Footer
  footer_desc: "Premium royal basmati rice, cultivated with heritage and exported with trust to markets across the globe.",
  footer_navigate: "Navigate",
  footer_products: "Products",
  footer_touch: "Get in Touch",
  footer_rights: "All rights reserved.",
  footer_tagline: "P.S.IMPEX | Premium Rice Exporters | Punjab, India",

  // About Page
  about_page_tag: "Our Story",
  about_page_title_1: "A Legacy of",
  about_page_title_2: "Quality",
  about_founder_tag: "Founder & Visionary",
  about_mission: "Our Mission",
  about_mission_text: "To deliver the finest quality Indian rice to global markets through sustainable sourcing, rigorous quality control, and reliable export partnerships.",
  about_vision: "Our Vision",
  about_vision_text: "To become the most trusted rice brand from India, recognized worldwide for premium quality, organic integrity, and excellence in every grain.",
  about_values: "Our Values",
  about_values_text: "Quality without compromise. Transparency in every transaction. Sustainability in our practices. Trust as the foundation of every partnership.",
  about_compass: "Our Compass",
  about_drives: "What Drives Us",

  // Products Page
  products_page_tag: "Our Products",
  products_page_title: "Rice Collection",
  products_page_desc: "Explore our comprehensive range of premium Basmati and Non-Basmati rice varieties, each cultivated and processed to the highest international standards.",
  products_tab_basmati: "Basmati Rice",
  products_tab_nonbasmati: "Non-Basmati Rice",
  products_tab_prf: "Pesticide Residue Free",
  products_packaging_tag: "Our Packaging",
  products_packaging_title: "Brand Packaging Design",
  products_packaging_desc: "Every bag of Fab Crops rice is packaged with care, reflecting the premium quality inside. Custom packaging available for private label clients.",
  products_quality_tag: "Our Commitment",
  products_quality_title: "Quality in Every Grain",

  // Blog
  blog_tag: "Insights & Updates",
  blog_title_1: "News &",
  blog_title_2: "Vlogs",
  blog_tab_news: "Industry News",
  blog_tab_vlogs: "Vlogs",

  // Exports Page
  exports_page_tag: "Worldwide Exports",
  exports_page_title: "Global Reach. Uncompromised Quality.",
  exports_page_desc: "As a trusted high-volume rice exporter from India, P.S.IMPEX delivers premium Fab Crops rice to importers and distributors across continents.",
  exports_markets_tag: "Our Markets",
  exports_markets_title: "Where We Export",
  exports_process_tag: "Our Process",
  exports_process_title: "From Farm to Port",
  exports_cert_tag: "Compliance & Trust",
  exports_cert_title: "Our Certifications",

  // WhatsApp
  whatsapp_text: "WhatsApp Us",
};

const hi = {
  nav_home: "होम",
  nav_about: "हमारे बारे में",
  nav_products: "उत्पाद",
  nav_exports: "निर्यात",
  nav_certifications: "प्रमाणपत्र",
  nav_blog: "समाचार और व्लॉग",
  nav_contact: "संपर्क",
  nav_call: "कॉल करें",
  hero_tagline: "प्रीमियम चावल के स्थापित निर्यातक",
  hero_desc: "रॉयल बासमती चावल, भारत के उपजाऊ मैदानों में उगाया गया। अफ्रीका, इंडोनेशिया और कनाडा के आयातकों द्वारा विश्वसनीय।",
  hero_explore: "उत्पाद देखें",
  hero_quote: "कोटेशन अनुरोध करें",
  stat_varieties: "चावल की किस्में",
  stat_countries: "देशों में निर्यात",
  stat_tonnes: "टन निर्यात",
  stat_quality: "गुणवत्ता आश्वासन",
  about_tag: "विरासत और विश्वास",
  about_title_1: "गुणवत्ता में जड़ें,",
  about_title_2: "गर्व",
  about_title_3: "के साथ उगाया",
  about_desc1: "पी.एस.इम्पेक्स, संस्थापक मंजोत सिंह के नेतृत्व में, भारत से एक प्रमुख चावल निर्यातक के रूप में स्थापित है। हमारा ब्रांड फैब क्रॉप्स बासमती और नॉन-बासमती चावल का बेहतरीन चयन प्रस्तुत करता है।",
  about_desc2: "FSSAI, APEDA और ISO प्रमाणन के साथ, हम सुनिश्चित करते हैं कि हर दाना अंतरराष्ट्रीय मानकों को पूरा करे।",
  about_learn: "हमारी कहानी जानें",
  products_tag: "हमारा संग्रह",
  products_title: "प्रीमियम चावल किस्में",
  basmati_tag: "प्रीमियम चयन",
  basmati_title: "बासमती चावल",
  basmati_desc: "भारतीय चावल निर्यात का मुकुट रत्न। लंबे दाने, सुगंधित और पूरी तरह से पुराना।",
  basmati_view: "सभी किस्में देखें",
  prf_tag: "प्रमाणित सुरक्षित",
  prf_title: "कीटनाशक अवशेष मुक्त",
  prf_desc: "स्वास्थ्य-सचेत वैश्विक बाजारों के लिए प्रमाणित PRF चावल।",
  prf_view: "PRF किस्में देखें",
  nonbasmati_tag: "रोज़ाना उत्कृष्टता",
  nonbasmati_title: "नॉन-बासमती चावल",
  nonbasmati_desc: "थोक उपभोग के लिए उच्च गुणवत्ता वाले नॉन-बासमती चावल। सुसंगत गुणवत्ता, प्रतिस्पर्धी मूल्य।",
  nonbasmati_view: "सभी किस्में देखें",
  export_tag: "वैश्विक उपस्थिति",
  export_title_1: "विश्वास का निर्यात",
  export_title_2: "दुनिया भर में",
  export_desc: "एक मान्यता प्राप्त उच्च-मात्रा निर्यातक के रूप में, पी.एस.इम्पेक्स कई महाद्वीपों में प्रीमियम भारतीय चावल भेजता है।",
  export_africa: "अफ्रीका",
  export_africa_desc: "पश्चिम और पूर्वी अफ्रीका में प्रमुख बाजार",
  export_indonesia: "इंडोनेशिया",
  export_indonesia_desc: "इंडोनेशियाई वितरकों को निरंतर आपूर्ति",
  export_canada: "कनाडा",
  export_canada_desc: "बढ़ते दक्षिण एशियाई समुदाय की सेवा",
  export_europe: "यूरोप",
  export_europe_desc: "यूरोपीय बाजारों में बढ़ती उपस्थिति",
  export_middleeast: "मध्य पूर्व",
  export_middleeast_desc: "खाड़ी और मध्य पूर्वी आयातकों के विश्वसनीय आपूर्तिकर्ता",
  cert_fssai: "FSSAI प्रमाणित",
  cert_apeda: "APEDA पंजीकृत निर्यातक",
  cert_iso: "ISO 9001:2015 प्रमाणित",
  cert_lei: "LEI पंजीकृत",
  cert_premium: "प्रीमियम गुणवत्ता चावल",
  cert_global: "विश्वसनीय वैश्विक निर्यातक",
  test_tag: "ग्राहक की आवाज़",
  test_title: "आयातकों द्वारा विश्वसनीय",
  cta_tag: "हमारे साथ जुड़ें",
  cta_title: "प्रीमियम चावल सोर्स करने के लिए तैयार?",
  cta_desc: "प्रतिस्पर्धी मूल्य, विश्वसनीय आपूर्ति और बेहतरीन गुणवत्ता के लिए पी.एस.इम्पेक्स से जुड़ें।",
  cta_btn: "संपर्क करें",
  contact_tag: "संपर्क करें",
  contact_title_1: "बात करते हैं",
  contact_title_2: "व्यापार",
  contact_desc: "चाहे आप आयातक, वितरक या थोक खरीदार हों, हम आपसे सुनना चाहेंगे।",
  contact_direct: "सीधा संपर्क",
  contact_phone: "फोन",
  contact_email: "ईमेल",
  contact_company: "कंपनी",
  contact_hours: "व्यापार का समय",
  contact_weekdays: "सोमवार - शनिवार",
  contact_weekend: "रविवार",
  contact_closed: "बंद",
  contact_form_title: "हमें संदेश भेजें",
  contact_form_desc: "नीचे फॉर्म भरें और हम 24 घंटे में आपसे संपर्क करेंगे।",
  contact_name: "पूरा नाम",
  contact_email_label: "ईमेल",
  contact_phone_label: "फोन",
  contact_company_label: "कंपनी",
  contact_message: "संदेश",
  contact_message_placeholder: "अपनी आवश्यकताएं बताएं (चावल का प्रकार, मात्रा, गंतव्य)...",
  contact_submit: "संदेश भेजें",
  contact_sending: "भेज रहे हैं...",
  contact_success: "धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।",
  contact_error: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
  footer_desc: "प्रीमियम रॉयल बासमती चावल, विरासत के साथ उगाया और विश्वास के साथ दुनिया भर में निर्यात।",
  footer_navigate: "नेविगेट करें",
  footer_products: "उत्पाद",
  footer_touch: "संपर्क में रहें",
  footer_rights: "सर्वाधिकार सुरक्षित।",
  footer_tagline: "पी.एस.इम्पेक्स | प्रीमियम चावल निर्यातक | पंजाब, भारत",
  about_page_tag: "हमारी कहानी",
  about_page_title_1: "गुणवत्ता की",
  about_page_title_2: "विरासत",
  about_founder_tag: "संस्थापक और दूरदर्शी",
  about_mission: "हमारा मिशन",
  about_mission_text: "टिकाऊ सोर्सिंग, कठोर गुणवत्ता नियंत्रण और विश्वसनीय निर्यात साझेदारी के माध्यम से वैश्विक बाजारों में बेहतरीन भारतीय चावल पहुंचाना।",
  about_vision: "हमारी दृष्टि",
  about_vision_text: "भारत का सबसे विश्वसनीय चावल ब्रांड बनना, प्रीमियम गुणवत्ता और हर दाने में उत्कृष्टता के लिए विश्व स्तर पर मान्यता प्राप्त।",
  about_values: "हमारे मूल्य",
  about_values_text: "बिना समझौते की गुणवत्ता। हर लेनदेन में पारदर्शिता। हमारी प्रथाओं में स्थिरता। हर साझेदारी की नींव के रूप में विश्वास।",
  about_compass: "हमारा दिशा-निर्देश",
  about_drives: "हमें क्या प्रेरित करता है",
  products_page_tag: "हमारे उत्पाद",
  products_page_title: "चावल संग्रह",
  products_page_desc: "हमारी प्रीमियम बासमती और नॉन-बासमती चावल किस्मों की व्यापक श्रृंखला देखें।",
  products_tab_basmati: "बासमती चावल",
  products_tab_nonbasmati: "नॉन-बासमती चावल",
  products_tab_prf: "कीटनाशक अवशेष मुक्त",
  products_packaging_tag: "हमारी पैकेजिंग",
  products_packaging_title: "ब्रांड पैकेजिंग डिज़ाइन",
  products_packaging_desc: "फैब क्रॉप्स चावल की हर थैली देखभाल के साथ पैक की जाती है।",
  products_quality_tag: "हमारी प्रतिबद्धता",
  products_quality_title: "हर दाने में गुणवत्ता",
  blog_tag: "अंतर्दृष्टि और अपडेट",
  blog_title_1: "समाचार और",
  blog_title_2: "व्लॉग",
  blog_tab_news: "उद्योग समाचार",
  blog_tab_vlogs: "व्लॉग",
  exports_page_tag: "विश्वव्यापी निर्यात",
  exports_page_title: "वैश्विक पहुंच। बेजोड़ गुणवत्ता।",
  exports_page_desc: "भारत से विश्वसनीय उच्च-मात्रा चावल निर्यातक के रूप में, पी.एस.इम्पेक्स महाद्वीपों में प्रीमियम फैब क्रॉप्स चावल पहुंचाता है।",
  exports_markets_tag: "हमारे बाजार",
  exports_markets_title: "हम कहाँ निर्यात करते हैं",
  exports_process_tag: "हमारी प्रक्रिया",
  exports_process_title: "खेत से बंदरगाह तक",
  exports_cert_tag: "अनुपालन और विश्वास",
  exports_cert_title: "हमारे प्रमाणपत्र",
  whatsapp_text: "व्हाट्सएप करें",
};

const ar = {
  nav_home: "الرئيسية",
  nav_about: "من نحن",
  nav_products: "المنتجات",
  nav_exports: "التصدير",
  nav_certifications: "الشهادات",
  nav_blog: "الأخبار والمدونات",
  nav_contact: "اتصل بنا",
  nav_call: "اتصل الآن",
  hero_tagline: "مصدرون معتمدون للأرز الفاخر",
  hero_desc: "أرز بسمتي ملكي، مزروع في سهول الهند الخصبة. موثوق به من قبل المستوردين في أفريقيا وإندونيسيا وكندا.",
  hero_explore: "استكشف المنتجات",
  hero_quote: "طلب عرض سعر",
  stat_varieties: "أصناف الأرز",
  stat_countries: "دول التصدير",
  stat_tonnes: "طن مُصدّر",
  stat_quality: "ضمان الجودة",
  about_tag: "التراث والثقة",
  about_title_1: "متجذرون في الجودة،",
  about_title_2: "نمت",
  about_title_3: "بفخر",
  about_desc1: "بي.إس.إمبكس، بقيادة المؤسس مانجوت سينغ، رسخت نفسها كمصدر رئيسي للأرز من الهند. علامتنا التجارية فاب كروبس تمثل أفضل اختيار من أرز البسمتي وغير البسمتي.",
  about_desc2: "مع شهادات FSSAI وAPEDA وISO، نضمن أن كل حبة تلبي أعلى المعايير الدولية.",
  about_learn: "اعرف قصتنا",
  products_tag: "مجموعتنا",
  products_title: "أصناف الأرز الفاخرة",
  basmati_tag: "اختيار فاخر",
  basmati_title: "أرز بسمتي",
  basmati_desc: "جوهرة تاج صادرات الأرز الهندي. حبوب طويلة، عطرية ومعتقة بشكل مثالي.",
  basmati_view: "عرض جميع الأصناف",
  prf_tag: "معتمد آمن",
  prf_title: "خالي من بقايا المبيدات",
  prf_desc: "أرز معتمد خالٍ من بقايا المبيدات للأسواق العالمية الواعية صحياً.",
  prf_view: "عرض أصناف PRF",
  nonbasmati_tag: "تميز يومي",
  nonbasmati_title: "أرز غير بسمتي",
  nonbasmati_desc: "أصناف أرز غير بسمتي عالية الجودة للاستهلاك بالجملة. جودة متسقة، أسعار تنافسية.",
  nonbasmati_view: "عرض جميع الأصناف",
  export_tag: "حضور عالمي",
  export_title_1: "تصدير الثقة",
  export_title_2: "حول العالم",
  export_desc: "كمصدر معترف به بكميات كبيرة، تشحن بي.إس.إمبكس الأرز الهندي الفاخر إلى عدة قارات.",
  export_africa: "أفريقيا",
  export_africa_desc: "أسواق رئيسية في غرب وشرق أفريقيا",
  export_indonesia: "إندونيسيا",
  export_indonesia_desc: "إمداد مستمر للموزعين الإندونيسيين",
  export_canada: "كندا",
  export_canada_desc: "خدمة المجتمع الجنوب آسيوي المتنامي",
  export_europe: "أوروبا",
  export_europe_desc: "توسع الحضور في الأسواق الأوروبية",
  export_middleeast: "الشرق الأوسط",
  export_middleeast_desc: "مورد موثوق لمستوردي الخليج والشرق الأوسط",
  cert_fssai: "شهادة FSSAI",
  cert_apeda: "مصدر مسجل APEDA",
  cert_iso: "شهادة ISO 9001:2015",
  cert_lei: "مسجل LEI",
  cert_premium: "أرز عالي الجودة",
  cert_global: "مصدر عالمي موثوق",
  test_tag: "أصوات العملاء",
  test_title: "موثوق من المستوردين",
  cta_tag: "شاركنا",
  cta_title: "مستعد للحصول على أرز فاخر؟",
  cta_desc: "تواصل مع بي.إس.إمبكس للحصول على أسعار تنافسية وإمداد موثوق وأفضل جودة أرز هندي.",
  cta_btn: "تواصل معنا",
  contact_tag: "اتصل بنا",
  contact_title_1: "لنتحدث عن",
  contact_title_2: "الأعمال",
  contact_desc: "سواء كنت مستورداً أو موزعاً أو تاجر جملة، نود أن نسمع منك.",
  contact_direct: "اتصال مباشر",
  contact_phone: "الهاتف",
  contact_email: "البريد الإلكتروني",
  contact_company: "الشركة",
  contact_hours: "ساعات العمل",
  contact_weekdays: "الاثنين - السبت",
  contact_weekend: "الأحد",
  contact_closed: "مغلق",
  contact_form_title: "أرسل لنا رسالة",
  contact_form_desc: "املأ النموذج أدناه وسنتواصل معك خلال 24 ساعة.",
  contact_name: "الاسم الكامل",
  contact_email_label: "البريد الإلكتروني",
  contact_phone_label: "الهاتف",
  contact_company_label: "الشركة",
  contact_message: "الرسالة",
  contact_message_placeholder: "أخبرنا عن متطلباتك (نوع الأرز، الكمية، الوجهة)...",
  contact_submit: "إرسال الرسالة",
  contact_sending: "جارٍ الإرسال...",
  contact_success: "شكراً! سنتواصل معك قريباً.",
  contact_error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
  footer_desc: "أرز بسمتي ملكي فاخر، مزروع بتراث ومُصدّر بثقة إلى الأسواق العالمية.",
  footer_navigate: "التنقل",
  footer_products: "المنتجات",
  footer_touch: "تواصل معنا",
  footer_rights: "جميع الحقوق محفوظة.",
  footer_tagline: "بي.إس.إمبكس | مصدرو أرز فاخر | البنجاب، الهند",
  about_page_tag: "قصتنا",
  about_page_title_1: "إرث من",
  about_page_title_2: "الجودة",
  about_founder_tag: "المؤسس والرؤية",
  about_mission: "مهمتنا",
  about_mission_text: "تقديم أفضل جودة أرز هندي للأسواق العالمية من خلال المصادر المستدامة ومراقبة الجودة الصارمة.",
  about_vision: "رؤيتنا",
  about_vision_text: "أن نصبح أكثر علامة أرز موثوقة من الهند، معترف بها عالمياً للجودة الفائقة.",
  about_values: "قيمنا",
  about_values_text: "جودة بلا تنازل. شفافية في كل معاملة. استدامة في ممارساتنا. الثقة كأساس لكل شراكة.",
  about_compass: "بوصلتنا",
  about_drives: "ما يحركنا",
  products_page_tag: "منتجاتنا",
  products_page_title: "مجموعة الأرز",
  products_page_desc: "استكشف مجموعتنا الشاملة من أصناف أرز البسمتي وغير البسمتي الفاخرة.",
  products_tab_basmati: "أرز بسمتي",
  products_tab_nonbasmati: "أرز غير بسمتي",
  products_tab_prf: "خالي من بقايا المبيدات",
  products_packaging_tag: "التعبئة والتغليف",
  products_packaging_title: "تصميم تعبئة العلامة التجارية",
  products_packaging_desc: "كل كيس من أرز فاب كروبس معبأ بعناية يعكس الجودة الفائقة بداخله.",
  products_quality_tag: "التزامنا",
  products_quality_title: "جودة في كل حبة",
  blog_tag: "رؤى وتحديثات",
  blog_title_1: "الأخبار و",
  blog_title_2: "المدونات",
  blog_tab_news: "أخبار الصناعة",
  blog_tab_vlogs: "المدونات المرئية",
  exports_page_tag: "صادرات عالمية",
  exports_page_title: "وصول عالمي. جودة لا تُضاهى.",
  exports_page_desc: "كمصدر أرز موثوق من الهند، تقدم بي.إس.إمبكس أرز فاب كروبس الفاخر للمستوردين والموزعين.",
  exports_markets_tag: "أسواقنا",
  exports_markets_title: "أين نصدر",
  exports_process_tag: "عمليتنا",
  exports_process_title: "من المزرعة إلى الميناء",
  exports_cert_tag: "الامتثال والثقة",
  exports_cert_title: "شهاداتنا",
  whatsapp_text: "واتساب",
};

const fr = {
  nav_home: "Accueil",
  nav_about: "À propos",
  nav_products: "Produits",
  nav_exports: "Exportations",
  nav_certifications: "Certifications",
  nav_blog: "Actualités & Vlogs",
  nav_contact: "Contact",
  nav_call: "Appelez",
  hero_tagline: "Exportateurs établis de riz premium",
  hero_desc: "Riz Basmati Royal, cultivé dans les plaines fertiles de l'Inde. Approuvé par les importateurs d'Afrique, d'Indonésie et du Canada.",
  hero_explore: "Explorer les produits",
  hero_quote: "Demander un devis",
  stat_varieties: "Variétés de riz",
  stat_countries: "Pays exportés",
  stat_tonnes: "Tonnes exportées",
  stat_quality: "Qualité assurée",
  about_tag: "Héritage et confiance",
  about_title_1: "Enraciné dans la qualité,",
  about_title_2: "Cultivé",
  about_title_3: "avec fierté",
  about_desc1: "P.S.IMPEX, dirigé par le fondateur Manjot Singh, s'est établi comme un exportateur de riz de premier plan en Inde. Notre marque Fab Crops représente la plus fine sélection de riz Basmati et Non-Basmati.",
  about_desc2: "Avec les certifications FSSAI, APEDA et ISO, nous garantissons que chaque grain répond aux normes internationales les plus élevées.",
  about_learn: "Découvrez notre histoire",
  products_tag: "Notre collection",
  products_title: "Variétés de riz premium",
  basmati_tag: "Sélection premium",
  basmati_title: "Riz Basmati",
  basmati_desc: "Le joyau des exportations de riz indien. Grains longs, aromatiques et parfaitement vieillis.",
  basmati_view: "Voir toutes les variétés",
  prf_tag: "Certifié sûr",
  prf_title: "Sans résidus de pesticides",
  prf_desc: "Riz certifié sans résidus de pesticides pour les marchés mondiaux soucieux de la santé.",
  prf_view: "Voir les variétés PRF",
  nonbasmati_tag: "Excellence quotidienne",
  nonbasmati_title: "Riz Non-Basmati",
  nonbasmati_desc: "Variétés de riz non-basmati de haute qualité pour la consommation en gros. Qualité constante, prix compétitifs.",
  nonbasmati_view: "Voir toutes les variétés",
  export_tag: "Présence mondiale",
  export_title_1: "Exporter la confiance",
  export_title_2: "dans le monde entier",
  export_desc: "En tant qu'exportateur reconnu à haut volume, P.S.IMPEX expédie du riz indien premium sur plusieurs continents.",
  export_africa: "Afrique",
  export_africa_desc: "Marchés majeurs en Afrique de l'Ouest et de l'Est",
  export_indonesia: "Indonésie",
  export_indonesia_desc: "Approvisionnement constant aux distributeurs indonésiens",
  export_canada: "Canada",
  export_canada_desc: "Au service de la diaspora sud-asiatique croissante",
  export_europe: "Europe",
  export_europe_desc: "Présence croissante sur les marchés européens",
  export_middleeast: "Moyen-Orient",
  export_middleeast_desc: "Fournisseur de confiance pour les importateurs du Golfe",
  cert_fssai: "Certifié FSSAI",
  cert_apeda: "Exportateur enregistré APEDA",
  cert_iso: "Certifié ISO 9001:2015",
  cert_lei: "Enregistré LEI",
  cert_premium: "Riz de qualité premium",
  cert_global: "Exportateur mondial de confiance",
  test_tag: "Voix des clients",
  test_title: "Approuvé par les importateurs",
  cta_tag: "Partenariat",
  cta_title: "Prêt à sourcer du riz premium?",
  cta_desc: "Contactez P.S.IMPEX pour des prix compétitifs, un approvisionnement fiable et la meilleure qualité de riz indien.",
  cta_btn: "Nous contacter",
  contact_tag: "Contactez-nous",
  contact_title_1: "Parlons",
  contact_title_2: "affaires",
  contact_desc: "Que vous soyez importateur, distributeur ou grossiste, nous serions ravis de vous entendre.",
  contact_direct: "Contact direct",
  contact_phone: "Téléphone",
  contact_email: "Email",
  contact_company: "Entreprise",
  contact_hours: "Heures d'ouverture",
  contact_weekdays: "Lundi - Samedi",
  contact_weekend: "Dimanche",
  contact_closed: "Fermé",
  contact_form_title: "Envoyez-nous un message",
  contact_form_desc: "Remplissez le formulaire ci-dessous et nous vous répondrons sous 24 heures.",
  contact_name: "Nom complet",
  contact_email_label: "Email",
  contact_phone_label: "Téléphone",
  contact_company_label: "Entreprise",
  contact_message: "Message",
  contact_message_placeholder: "Décrivez vos besoins (type de riz, quantité, destination)...",
  contact_submit: "Envoyer",
  contact_sending: "Envoi en cours...",
  contact_success: "Merci! Nous vous répondrons bientôt.",
  contact_error: "Une erreur s'est produite. Veuillez réessayer.",
  footer_desc: "Riz basmati royal premium, cultivé avec héritage et exporté avec confiance vers les marchés du monde entier.",
  footer_navigate: "Navigation",
  footer_products: "Produits",
  footer_touch: "Contactez-nous",
  footer_rights: "Tous droits réservés.",
  footer_tagline: "P.S.IMPEX | Exportateurs de riz premium | Punjab, Inde",
  about_page_tag: "Notre histoire",
  about_page_title_1: "Un héritage de",
  about_page_title_2: "qualité",
  about_founder_tag: "Fondateur et visionnaire",
  about_mission: "Notre mission",
  about_mission_text: "Livrer la meilleure qualité de riz indien aux marchés mondiaux grâce à un approvisionnement durable et un contrôle qualité rigoureux.",
  about_vision: "Notre vision",
  about_vision_text: "Devenir la marque de riz la plus fiable d'Inde, reconnue mondialement pour sa qualité premium.",
  about_values: "Nos valeurs",
  about_values_text: "Qualité sans compromis. Transparence dans chaque transaction. Durabilité dans nos pratiques. Confiance comme fondement de chaque partenariat.",
  about_compass: "Notre boussole",
  about_drives: "Ce qui nous anime",
  products_page_tag: "Nos produits",
  products_page_title: "Collection de riz",
  products_page_desc: "Explorez notre gamme complète de variétés de riz Basmati et Non-Basmati premium.",
  products_tab_basmati: "Riz Basmati",
  products_tab_nonbasmati: "Riz Non-Basmati",
  products_tab_prf: "Sans résidus de pesticides",
  products_packaging_tag: "Notre emballage",
  products_packaging_title: "Design d'emballage de marque",
  products_packaging_desc: "Chaque sac de riz Fab Crops est emballé avec soin.",
  products_quality_tag: "Notre engagement",
  products_quality_title: "Qualité dans chaque grain",
  blog_tag: "Actualités et mises à jour",
  blog_title_1: "Actualités &",
  blog_title_2: "Vlogs",
  blog_tab_news: "Actualités de l'industrie",
  blog_tab_vlogs: "Vlogs",
  exports_page_tag: "Exportations mondiales",
  exports_page_title: "Portée mondiale. Qualité sans compromis.",
  exports_page_desc: "En tant qu'exportateur de riz de confiance, P.S.IMPEX livre du riz Fab Crops premium aux importateurs du monde entier.",
  exports_markets_tag: "Nos marchés",
  exports_markets_title: "Où nous exportons",
  exports_process_tag: "Notre processus",
  exports_process_title: "De la ferme au port",
  exports_cert_tag: "Conformité et confiance",
  exports_cert_title: "Nos certifications",
  whatsapp_text: "WhatsApp",
};

const id = {
  nav_home: "Beranda",
  nav_about: "Tentang",
  nav_products: "Produk",
  nav_exports: "Ekspor",
  nav_certifications: "Sertifikasi",
  nav_blog: "Berita & Vlog",
  nav_contact: "Kontak",
  nav_call: "Hubungi",
  hero_tagline: "Eksportir Beras Premium Terpercaya",
  hero_desc: "Beras Basmati Royal, ditanam di dataran subur India. Dipercaya oleh importir di Afrika, Indonesia & Kanada.",
  hero_explore: "Jelajahi Produk",
  hero_quote: "Minta Penawaran",
  stat_varieties: "Varietas Beras",
  stat_countries: "Negara Ekspor",
  stat_tonnes: "Ton Diekspor",
  stat_quality: "Jaminan Mutu",
  about_tag: "Warisan & Kepercayaan",
  about_title_1: "Berakar pada Kualitas,",
  about_title_2: "Tumbuh",
  about_title_3: "dengan Bangga",
  about_desc1: "P.S.IMPEX, dipimpin oleh pendiri Manjot Singh, telah menjadi eksportir beras terkemuka dari India. Brand kami Fab Crops mewakili pilihan terbaik beras Basmati dan Non-Basmati.",
  about_desc2: "Dengan sertifikasi FSSAI, APEDA, dan ISO, kami memastikan setiap butir memenuhi standar internasional tertinggi.",
  about_learn: "Pelajari Kisah Kami",
  products_tag: "Koleksi Kami",
  products_title: "Varietas Beras Premium",
  basmati_tag: "Pilihan Premium",
  basmati_title: "Beras Basmati",
  basmati_desc: "Mahkota ekspor beras India. Butir panjang, aromatik, dan berumur sempurna.",
  basmati_view: "Lihat Semua Varietas",
  prf_tag: "Bersertifikat Aman",
  prf_title: "Bebas Residu Pestisida",
  prf_desc: "Beras bersertifikat PRF untuk pasar global yang sadar kesehatan.",
  prf_view: "Lihat Varietas PRF",
  nonbasmati_tag: "Keunggulan Sehari-hari",
  nonbasmati_title: "Beras Non-Basmati",
  nonbasmati_desc: "Varietas beras non-basmati berkualitas tinggi untuk konsumsi massal. Kualitas konsisten, harga kompetitif.",
  nonbasmati_view: "Lihat Semua Varietas",
  export_tag: "Kehadiran Global",
  export_title_1: "Mengekspor Kepercayaan",
  export_title_2: "ke Seluruh Dunia",
  export_desc: "Sebagai eksportir volume tinggi yang diakui, P.S.IMPEX mengirimkan beras India premium ke beberapa benua.",
  export_africa: "Afrika",
  export_africa_desc: "Pasar utama di Afrika Barat dan Timur",
  export_indonesia: "Indonesia",
  export_indonesia_desc: "Pasokan konsisten untuk distributor Indonesia",
  export_canada: "Kanada",
  export_canada_desc: "Melayani diaspora Asia Selatan yang berkembang",
  export_europe: "Eropa",
  export_europe_desc: "Kehadiran yang berkembang di pasar Eropa",
  export_middleeast: "Timur Tengah",
  export_middleeast_desc: "Pemasok terpercaya untuk importir Teluk & Timur Tengah",
  test_tag: "Suara Klien",
  test_title: "Dipercaya oleh Importir",
  cta_tag: "Bermitra dengan Kami",
  cta_title: "Siap Mendapatkan Beras Premium?",
  cta_desc: "Hubungi P.S.IMPEX untuk harga kompetitif, pasokan andal, dan kualitas beras India terbaik.",
  cta_btn: "Hubungi Kami",
  contact_tag: "Hubungi Kami",
  contact_title_1: "Mari Bicara",
  contact_title_2: "Bisnis",
  contact_desc: "Apakah Anda importir, distributor, atau pedagang grosir, kami ingin mendengar dari Anda.",
  contact_direct: "Kontak Langsung",
  contact_phone: "Telepon",
  contact_email: "Email",
  contact_company: "Perusahaan",
  contact_form_title: "Kirim Pesan",
  contact_form_desc: "Isi formulir di bawah dan kami akan menghubungi Anda dalam 24 jam.",
  contact_name: "Nama Lengkap",
  contact_email_label: "Email",
  contact_phone_label: "Telepon",
  contact_company_label: "Perusahaan",
  contact_message: "Pesan",
  contact_message_placeholder: "Ceritakan kebutuhan Anda (jenis beras, kuantitas, tujuan)...",
  contact_submit: "Kirim Pesan",
  contact_sending: "Mengirim...",
  contact_success: "Terima kasih! Kami akan segera menghubungi Anda.",
  contact_error: "Terjadi kesalahan. Silakan coba lagi.",
  contact_hours: "Jam Kerja",
  contact_weekdays: "Senin - Sabtu",
  contact_weekend: "Minggu",
  contact_closed: "Tutup",
  footer_desc: "Beras basmati royal premium, ditanam dengan warisan dan diekspor dengan kepercayaan ke pasar global.",
  footer_navigate: "Navigasi",
  footer_products: "Produk",
  footer_touch: "Hubungi Kami",
  footer_rights: "Hak cipta dilindungi.",
  footer_tagline: "P.S.IMPEX | Eksportir Beras Premium | Punjab, India",
  about_page_tag: "Kisah Kami",
  about_page_title_1: "Warisan",
  about_page_title_2: "Kualitas",
  about_founder_tag: "Pendiri & Visioner",
  about_mission: "Misi Kami",
  about_mission_text: "Menghadirkan kualitas beras India terbaik ke pasar global melalui sumber berkelanjutan dan kontrol kualitas ketat.",
  about_vision: "Visi Kami",
  about_vision_text: "Menjadi merek beras paling terpercaya dari India, diakui secara global untuk kualitas premium.",
  about_values: "Nilai Kami",
  about_values_text: "Kualitas tanpa kompromi. Transparansi dalam setiap transaksi. Keberlanjutan dalam praktik kami. Kepercayaan sebagai fondasi setiap kemitraan.",
  about_compass: "Kompas Kami",
  about_drives: "Apa yang Mendorong Kami",
  products_page_tag: "Produk Kami",
  products_page_title: "Koleksi Beras",
  products_page_desc: "Jelajahi rangkaian lengkap varietas beras Basmati dan Non-Basmati premium kami.",
  products_tab_basmati: "Beras Basmati",
  products_tab_nonbasmati: "Beras Non-Basmati",
  products_tab_prf: "Bebas Residu Pestisida",
  products_packaging_tag: "Kemasan Kami",
  products_packaging_title: "Desain Kemasan Merek",
  products_packaging_desc: "Setiap kantong beras Fab Crops dikemas dengan hati-hati.",
  products_quality_tag: "Komitmen Kami",
  products_quality_title: "Kualitas di Setiap Butir",
  blog_tag: "Wawasan & Pembaruan",
  blog_title_1: "Berita &",
  blog_title_2: "Vlog",
  blog_tab_news: "Berita Industri",
  blog_tab_vlogs: "Vlog",
  exports_page_tag: "Ekspor Dunia",
  exports_page_title: "Jangkauan Global. Kualitas Tanpa Kompromi.",
  exports_page_desc: "Sebagai eksportir beras terpercaya dari India, P.S.IMPEX menghadirkan beras Fab Crops premium ke importir dan distributor.",
  exports_markets_tag: "Pasar Kami",
  exports_markets_title: "Kemana Kami Mengekspor",
  exports_process_tag: "Proses Kami",
  exports_process_title: "Dari Sawah ke Pelabuhan",
  exports_cert_tag: "Kepatuhan & Kepercayaan",
  exports_cert_title: "Sertifikasi Kami",
  whatsapp_text: "WhatsApp",
};

const sw = {
  nav_home: "Nyumbani",
  nav_about: "Kuhusu",
  nav_products: "Bidhaa",
  nav_exports: "Usafirishaji",
  nav_certifications: "Vyeti",
  nav_blog: "Habari & Vlogi",
  nav_contact: "Wasiliana",
  nav_call: "Piga Simu",
  hero_tagline: "Wasafirishaji Walioimarishwa wa Mchele wa Hali ya Juu",
  hero_desc: "Mchele wa Basmati wa Kifalme, uliolimwa katika tambarare zenye rutuba za India. Unaoaminiwa na waagizaji kutoka Afrika, Indonesia na Kanada.",
  hero_explore: "Chunguza Bidhaa",
  hero_quote: "Omba Nukuu",
  stat_varieties: "Aina za Mchele",
  stat_countries: "Nchi Zilizosafirishwa",
  stat_tonnes: "Tani Zilizosafirishwa",
  stat_quality: "Ubora Uliohakikishwa",
  about_tag: "Urithi na Uaminifu",
  about_title_1: "Imejikita katika Ubora,",
  about_title_2: "Imekuzwa",
  about_title_3: "kwa Kiburi",
  about_desc1: "P.S.IMPEX, inayoongozwa na mwanzilishi Manjot Singh, imejiimarisha kama msafirishaji mkuu wa mchele kutoka India. Biashara yetu Fab Crops inawakilisha uteuzi bora wa mchele wa Basmati na wasio Basmati.",
  about_desc2: "Kwa vyeti vya FSSAI, APEDA, na ISO, tunahakikisha kila punje inakidhi viwango vya juu vya kimataifa.",
  about_learn: "Jifunze Hadithi Yetu",
  products_tag: "Mkusanyiko Wetu",
  products_title: "Aina za Mchele wa Hali ya Juu",
  basmati_tag: "Uteuzi wa Hali ya Juu",
  basmati_title: "Mchele wa Basmati",
  basmati_desc: "Johari ya taji ya usafirishaji wa mchele wa India. Punje ndefu, zenye harufu nzuri na zilizozeeshwa kikamilifu.",
  basmati_view: "Angalia Aina Zote",
  prf_tag: "Imethibitishwa Salama",
  prf_title: "Huru ya Mabaki ya Dawa",
  prf_desc: "Mchele uliothibitishwa PRF kwa masoko ya kimataifa yanayojali afya.",
  prf_view: "Angalia Aina za PRF",
  nonbasmati_tag: "Ubora wa Kila Siku",
  nonbasmati_title: "Mchele Usio Basmati",
  nonbasmati_desc: "Aina za mchele usio basmati wa ubora wa juu kwa matumizi ya jumla. Ubora thabiti, bei shindani.",
  nonbasmati_view: "Angalia Aina Zote",
  export_tag: "Uwepo wa Kimataifa",
  export_title_1: "Kusafirisha Uaminifu",
  export_title_2: "Duniani Kote",
  export_desc: "Kama msafirishaji anayetambuliwa wa kiasi kikubwa, P.S.IMPEX inasafirisha mchele wa India wa hali ya juu kwa mabara mengi.",
  export_africa: "Afrika",
  export_africa_desc: "Masoko makubwa katika Afrika Magharibi na Mashariki",
  export_indonesia: "Indonesia",
  export_indonesia_desc: "Ugavi thabiti kwa wasambazaji wa Indonesia",
  export_canada: "Kanada",
  export_canada_desc: "Kuhudumia diaspora ya Asia Kusini inayokua",
  export_europe: "Ulaya",
  export_europe_desc: "Uwepo unaokua katika masoko ya Ulaya",
  export_middleeast: "Mashariki ya Kati",
  export_middleeast_desc: "Msambazaji anayeaminiwa kwa waagizaji wa Ghuba",
  test_tag: "Sauti za Wateja",
  test_title: "Inaaminiwa na Waagizaji",
  cta_tag: "Shirikiana Nasi",
  cta_title: "Uko Tayari Kupata Mchele wa Hali ya Juu?",
  cta_desc: "Wasiliana na P.S.IMPEX kwa bei shindani, ugavi wa kuaminika, na ubora bora wa mchele wa India.",
  cta_btn: "Wasiliana Nasi",
  contact_tag: "Wasiliana Nasi",
  contact_title_1: "Tuzungumze",
  contact_title_2: "Biashara",
  contact_desc: "Iwe wewe ni mwagizaji, msambazaji au mfanyabiashara wa jumla, tungependa kusikia kutoka kwako.",
  contact_direct: "Mawasiliano ya Moja kwa Moja",
  contact_phone: "Simu",
  contact_email: "Barua pepe",
  contact_company: "Kampuni",
  contact_form_title: "Tutumie Ujumbe",
  contact_form_desc: "Jaza fomu hapa chini na tutawasiliana nawe ndani ya masaa 24.",
  contact_name: "Jina Kamili",
  contact_email_label: "Barua pepe",
  contact_phone_label: "Simu",
  contact_company_label: "Kampuni",
  contact_message: "Ujumbe",
  contact_message_placeholder: "Tuambie kuhusu mahitaji yako (aina ya mchele, kiasi, mwelekeo)...",
  contact_submit: "Tuma Ujumbe",
  contact_sending: "Inatuma...",
  contact_success: "Asante! Tutawasiliana nawe hivi karibuni.",
  contact_error: "Kuna kosa limetokea. Tafadhali jaribu tena.",
  contact_hours: "Saa za Biashara",
  contact_weekdays: "Jumatatu - Jumamosi",
  contact_weekend: "Jumapili",
  contact_closed: "Imefungwa",
  footer_desc: "Mchele wa basmati wa kifalme wa hali ya juu, uliolimwa kwa urithi na kusafirishwa kwa uaminifu kwa masoko ya ulimwengu.",
  footer_navigate: "Tembeza",
  footer_products: "Bidhaa",
  footer_touch: "Wasiliana",
  footer_rights: "Haki zote zimehifadhiwa.",
  footer_tagline: "P.S.IMPEX | Wasafirishaji wa Mchele wa Hali ya Juu | Punjab, India",
  about_page_tag: "Hadithi Yetu",
  about_page_title_1: "Urithi wa",
  about_page_title_2: "Ubora",
  about_founder_tag: "Mwanzilishi na Mwonaji",
  about_mission: "Dhamira Yetu",
  about_mission_text: "Kutoa mchele wa India wa ubora bora kwa masoko ya kimataifa kupitia vyanzo endelevu na udhibiti mkali wa ubora.",
  about_vision: "Maono Yetu",
  about_vision_text: "Kuwa biashara ya mchele inayoaminiwa zaidi kutoka India, inayotambuliwa kimataifa kwa ubora wa hali ya juu.",
  about_values: "Maadili Yetu",
  about_values_text: "Ubora bila maelewano. Uwazi katika kila muamala. Uendelevu katika mazoea yetu. Uaminifu kama msingi wa kila ushirikiano.",
  about_compass: "Dira Yetu",
  about_drives: "Kinachotusukuma",
  products_page_tag: "Bidhaa Zetu",
  products_page_title: "Mkusanyiko wa Mchele",
  products_page_desc: "Chunguza aina zetu kamili za mchele wa Basmati na Usio Basmati wa hali ya juu.",
  products_tab_basmati: "Mchele wa Basmati",
  products_tab_nonbasmati: "Mchele Usio Basmati",
  products_tab_prf: "Huru ya Mabaki ya Dawa",
  products_packaging_tag: "Ufungaji Wetu",
  products_packaging_title: "Muundo wa Ufungaji wa Biashara",
  products_packaging_desc: "Kila mfuko wa mchele wa Fab Crops umefungashwa kwa uangalifu.",
  products_quality_tag: "Ahadi Yetu",
  products_quality_title: "Ubora katika Kila Punje",
  blog_tag: "Maarifa na Sasisho",
  blog_title_1: "Habari &",
  blog_title_2: "Vlogi",
  blog_tab_news: "Habari za Sekta",
  blog_tab_vlogs: "Vlogi",
  exports_page_tag: "Usafirishaji wa Kimataifa",
  exports_page_title: "Ufikiaji wa Kimataifa. Ubora Usio na Maelewano.",
  exports_page_desc: "Kama msafirishaji wa mchele anayeaminiwa kutoka India, P.S.IMPEX hutoa mchele wa Fab Crops wa hali ya juu.",
  exports_markets_tag: "Masoko Yetu",
  exports_markets_title: "Tunasafirisha Wapi",
  exports_process_tag: "Mchakato Wetu",
  exports_process_title: "Kutoka Shambani hadi Bandarini",
  exports_cert_tag: "Utiifu na Uaminifu",
  exports_cert_title: "Vyeti Vyetu",
  whatsapp_text: "WhatsApp",
};

export const translations = { en, hi, ar, fr, id, sw };
